import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Store dla zarządzania warstwami (Widoczność / Blokowanie)
 */
const useLayerStore = create(
  persist(
    (set) => ({
      layers: {
        furniture: { id: 'furniture', label: 'Aranżacja', isVisible: true, isLocked: false },
        shapes: { id: 'shapes', label: 'Kształty i strzałki', isVisible: true, isLocked: false },
        texts: { id: 'texts', label: 'Tekst', isVisible: true, isLocked: false },
        manualDimensions: { id: 'manualDimensions', label: 'Linie wymiarowe', isVisible: true, isLocked: false },
        roomLabels: { id: 'roomLabels', label: 'Nazwy pomieszczeń', isVisible: true, isLocked: false },
        logo: { id: 'logo', label: 'Logotyp', isVisible: true, isLocked: false },
        background: { id: 'background', label: 'Podkład', isVisible: true, isLocked: false },
        dimensions: { id: 'dimensions', label: 'Wymiary', isVisible: true, isLocked: false },
        grid: { id: 'grid', label: 'Siatka', isVisible: true, isLocked: false },
      },
      toggleVisibility: (layerId) => set((state) => ({
        layers: {
          ...state.layers,
          [layerId]: { ...state.layers[layerId], isVisible: !state.layers[layerId].isVisible }
        }
      })),
      toggleLock: (layerId) => set((state) => ({
        layers: {
          ...state.layers,
          [layerId]: { ...state.layers[layerId], isLocked: !state.layers[layerId].isLocked }
        }
      }))
    }),
    {
      name: 'floorcraft-layer-storage',
      partialize: (state) => ({ layers: state.layers }),
      merge: (persistedState, currentState) => {
        // Deep merge layers to ensure new layers are added to old state
        return {
          ...currentState,
          layers: {
            ...currentState.layers,
            ...(persistedState.layers || {}),
            // Ensure manualDimensions exists even if not in persisted state
            manualDimensions: persistedState.layers?.manualDimensions || currentState.layers.manualDimensions
          },
        };
      },
    }
  )
);

export default useLayerStore;